module.exports = __webpack_public_path__ + "static/media/status.ed6df8a3.svg";